/**
 * Base API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RubrikConfigEntry { 
    rubrik?: RubrikConfigEntry.RubrikEnum;
    id?: string;
    components?: Array<string>;
    rubrikType?: RubrikConfigEntry.RubrikTypeEnum;
    hashCode?: string;
    titel?: string;
}
export namespace RubrikConfigEntry {
    export type RubrikEnum = 'GB_AUSZUG_UNBEKANNT' | 'GB_AUSZUG_LIG' | 'GB_AUSZUG_MIT' | 'GB_AUSZUG_STW' | 'GB_AUSZUG_SDR' | 'GB_AUSZUG_SEYBUCH' | 'GB_UEBERSICHT_LIG' | 'GB_UEBERSICHT_MIT' | 'GB_UEBERSICHT_STW' | 'GB_UEBERSICHT_SDR' | 'GB_DETAIL_PFANDRECHT' | 'GB_DETAIL_STANDARDRECHT' | 'GB_DETAIL_GRUNDSTUECK';
    export const RubrikEnum = {
        GB_AUSZUG_UNBEKANNT: 'GB_AUSZUG_UNBEKANNT' as RubrikEnum,
        GB_AUSZUG_LIG: 'GB_AUSZUG_LIG' as RubrikEnum,
        GB_AUSZUG_MIT: 'GB_AUSZUG_MIT' as RubrikEnum,
        GB_AUSZUG_STW: 'GB_AUSZUG_STW' as RubrikEnum,
        GB_AUSZUG_SDR: 'GB_AUSZUG_SDR' as RubrikEnum,
        GB_AUSZUG_SEYBUCH: 'GB_AUSZUG_SEYBUCH' as RubrikEnum,
        GB_UEBERSICHT_LIG: 'GB_UEBERSICHT_LIG' as RubrikEnum,
        GB_UEBERSICHT_MIT: 'GB_UEBERSICHT_MIT' as RubrikEnum,
        GB_UEBERSICHT_STW: 'GB_UEBERSICHT_STW' as RubrikEnum,
        GB_UEBERSICHT_SDR: 'GB_UEBERSICHT_SDR' as RubrikEnum,
        GB_DETAIL_PFANDRECHT: 'GB_DETAIL_PFANDRECHT' as RubrikEnum,
        GB_DETAIL_STANDARDRECHT: 'GB_DETAIL_STANDARDRECHT' as RubrikEnum,
        GB_DETAIL_GRUNDSTUECK: 'GB_DETAIL_GRUNDSTUECK' as RubrikEnum
    };
    export type RubrikTypeEnum = 'PRINT' | 'VIEW';
    export const RubrikTypeEnum = {
        PRINT: 'PRINT' as RubrikTypeEnum,
        VIEW: 'VIEW' as RubrikTypeEnum
    };
}


